export function Footer() {
  return (
    <footer className="footer">
      <div className="container footerGrid">
        <div className="footerCol footerColBrand">
          <a
            href="https://buyrights.ru/"
            className="footerLogoLink"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="BuyRights — на главный сайт"
          >
            <img
              src="https://buyrights.ru/wp-content/uploads/2025/08/logo-full-1.svg"
              alt="BuyRights"
              className="footerLogo"
              width="200"
              height="52"
              loading="lazy"
            />
          </a>
          <p className="footerCompany">
            <strong>ООО «КупиПрава»</strong>
            <br />
            ИНН 7735208230
          </p>
          <nav className="footerLegal" aria-label="Политики">
            <a
              className="footerLink"
              href="https://buyrights.ru/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Политика конфиденциальности
            </a>
          </nav>
        </div>

        <div className="footerCol">
          <nav className="footerNav" aria-label="Навигация">
            <a className="footerNavLink" href="https://buyrights.ru/protect-rights/" target="_blank" rel="noopener noreferrer">
              Защитить права
            </a>
            <a className="footerNavLink" href="https://buyrights.ru/notice/" target="_blank"  rel="noopener noreferrer">
              Я получил претензию
            </a>
            <a className="footerNavLink" href="https://buyrights.ru/cases/" target="_blank" rel="noopener noreferrer">
              Кейсы
            </a>
            <a className="footerNavLink" href="https://buyrights.ru/about/" target="_blank" rel="noopener noreferrer">
              О нас
            </a>
            <a className="footerNavLink" href="https://buyrights.ru/blog/" target="_blank" rel="noopener noreferrer">
              Блог
            </a>
            <a className="footerNavLink" href="https://buyrights.ru/contacts/" target="_blank" rel="noopener noreferrer">
              Контакты
            </a>
            <a className="footerNavLink" href="https://fixator-app.ru/" target="_blank" rel="noopener noreferrer">
              Фиксатор - сервис для фиксации нарушений
            </a>
          </nav>
        </div>

        <div className="footerCol">
          <p className="footerColTitle">Контакты</p>
          <p className="footerMuted">Звонок по России бесплатный</p>
          <p className="footerContact">
            <a href="tel:+79300366004" className="footerLink">
              +7 (930) 036-60-04
            </a>
          </p>
          <p className="footerContact">
            <a href="#" className="footerLink">
              Обратный звонок
            </a>
          </p>

          <p className="footerColTitle">Электронная почта</p>
          <p className="footerContact">
            <a href="mailto:urist@buyrights.ru" className="footerLink">
              urist@buyrights.ru
            </a>
          </p>

          <p className="footerColTitle">Адрес</p>
          <p className="footerAddress">
            121205, город Москва, мун. округ Можайский, тер. инновационного центра Сколково, б-р Большой, д. 42, стр. 1
          </p>
        </div>

        <div className="footerCol footerColRight">
          <img
            src="https://buyrights.ru/wp-content/uploads/2025/08/skolkovo-optimized.png"
            alt="Сколково"
            className="footerSkolkovo"
            width="160"
            height="67"
            loading="lazy"
          />
          <div className="footerSocialRow">
            <div className="footerSocialBlock">
              <p className="footerColTitle">Соц. сети</p>
              <a href="https://vk.com/buyrights" target="_blank" rel="noopener noreferrer" className="footerIconLink" aria-label="ВКонтакте">
                <img src="https://buyrights.ru/wp-content/uploads/2025/08/icon-vk-optimized.png" alt="" width="32" height="32" loading="lazy" />
              </a>
            </div>
            <div className="footerSocialBlock">
              <p className="footerColTitle">Мессенджеры</p>
              <div className="footerMessengers">
                <a href="https://wa.me/79919879839" target="_blank" rel="noopener noreferrer" className="footerIconLink" aria-label="WhatsApp">
                  <img src="https://buyrights.ru/wp-content/uploads/2025/08/icon-whatsapp-optimized.png" alt="" width="32" height="32" loading="lazy" />
                </a>
                <a href="https://t.me/buyrights_1author" target="_blank" rel="noopener noreferrer" className="footerIconLink" aria-label="Telegram">
                  <img src="https://buyrights.ru/wp-content/uploads/2025/08/icon-telegram-optimized.png" alt="" width="32" height="32" loading="lazy" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
